var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"curriculum-receiver"},[_c('div',{staticClass:"to"},[_vm._v("TO :")]),_c('avatar-image',{staticClass:"avatar-image",attrs:{"src":_vm.student.avatarImageUrl,"purpose":"receiver"}}),_c('div',{staticClass:"receiver"},[_vm._v(_vm._s(_vm.student.name))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }